import {
  ChartBarIcon,
  Cog6ToothIcon,
  HomeIcon,
  ArchiveBoxArrowDownIcon,
  HomeModernIcon,
  ScaleIcon,
  TruckIcon,
  ArrowPathRoundedSquareIcon,
  ChartPieIcon,
  NewspaperIcon,
  WrenchIcon,
  BuildingStorefrontIcon,
  ClipboardDocumentCheckIcon,
  ChartBarSquareIcon,
  MegaphoneIcon,
} from "@heroicons/react/24/outline";
import { isSunDistribution, isFeatureFlag } from "./utility";

export default function routes(pathname, user_type) {
  var title;
  var routes;

  const isCFIA = user_type === 2;
  const sunDistribution = isSunDistribution();

  routes = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: HomeIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Export label",
      href: "/export-label",
      icon: NewspaperIcon,
      current: false,
      showInMenu: isCFIA,
    },
    {
      name: "Receiving",
      icon: ArchiveBoxArrowDownIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution,
      children: [
        { name: "Add new", href: "/receiving-invoices/new", current: false },
        { name: "History", href: "/receiving-invoices", current: false },
        { name: "Records", href: "/receiving-index", current: false },
      ],
    },
    {
      name: "Production",
      icon: HomeModernIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution,
      children: [
        {
          name: "Manufacture Product",
          href: "/manufacture-product",
          current: false,
        },
        { name: "History", href: "/manufactured-products", current: false },
        { name: "Calendar", href: "/product-calendar", current: false },
      ],
    },
    {
      name: "In-Process Monitoring",
      href: "/in-process-monitoring",
      icon: ClipboardDocumentCheckIcon,
      current: false,
      showInMenu:
        !isCFIA && isFeatureFlag("in_process_monitoring") && !sunDistribution,
    },
    {
      name: "Packaging",
      icon: ScaleIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution,
      children: [
        {
          name: "Package Product",
          href: "/packaging-new",
          current: false,
        },
        // {
        //   name: "Package Product 2",
        //   href: "/packaging-new2",
        //   current: false,
        // },
        { name: "History", href: "/packaging-reports", current: false },
        { name: "Calendar", href: "/packaging-calendar", current: false },
      ],
    },
    {
      name: "Orders",
      icon: NewspaperIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution,
      open: false,
      children: [
        { name: "Create", href: "/create-order" },
        { name: "Manage Orders", href: "/orders" },
        { name: "Import SKUs", href: "/import-skus" },
      ],
    },
    {
      name: "Shipping",
      href: "/shippings",
      icon: TruckIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Sun Customers",
      href: "/sun-customers",
      icon: BuildingStorefrontIcon,
      current: false,
      showInMenu: sunDistribution,
    },
    {
      name: "Loblaws SKUs",
      href: "/loblaws-skus",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: sunDistribution,
    },
    {
      name: "Walmart SKUs",
      href: "/walmart-skus",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: sunDistribution,
    },
    {
      name: "Sobeys SKUs",
      href: "/sobeys-skus",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: sunDistribution,
    },
    {
      name: "Inventory",
      icon: ScaleIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution,
      children: [
        {
          name: "Raw Material",
          href: "/inventory-raw-material",
          current: false,
        },
        {
          name: "Manufactured",
          href: "/inventory-manufactured-material",
          current: false,
        },
      ],
    },
    {
      name: "Traceability",
      href: "/traceability",
      icon: ArrowPathRoundedSquareIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution,
    },
    {
      name: "QA",
      icon: ChartBarIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution && isFeatureFlag("isQa"),
      children: [
        {
          name: " Maintenance",
          href: "/equipment-maintenance",
          current: false,
        },
        {
          name: "Temperature",
          href: "/temperature-sensors",
          current: false,
        },
        {
          name: "Lab Samples",
          href: "/lab-samples",
          current: false,
        },
        {
          name: "Visitors",
          href: "/visitors",
          current: false,
        },
      ],
    },
    {
      name: "Recipes",
      href: "/recipes",
      icon: ChartPieIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution,
    },
    {
      name: "Campaigns",
      icon: MegaphoneIcon,
      current: false,
      showInMenu: !isCFIA && sunDistribution,
      children: [
        { name: "Campaigns", href: "/campaigns", current: false },
        { name: "Campaign Users", href: "/campaign-users", current: false },
      ],
    },
    {
      name: "SUN Products",
      href: "/sun-products",
      icon: WrenchIcon,
      current: false,
      showInMenu: !isCFIA && sunDistribution,
    },
    {
      name: isSunDistribution() ? "Solmaz Products" : "Products",
      href: "/my-products",
      icon: WrenchIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Setup",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution,
      open: false,
      children: [
        {
          name: "Allergens",
          href: "/product-allergens",
          current: false,
        },
        { name: "BOM items", href: "/bom-items", current: false },
        { name: "Brands", href: "/brands", current: false },
        {
          name: "Certification Types",
          href: "/certification-types",
          current: false,
        },
        { name: "Claims", href: "/product-claims", current: false },
        { name: "Customers", href: "/customers", current: false },
        { name: "Employees", href: "/employees", current: false },
        { name: "Manufacturers", href: "/manufacturers", current: false },
        { name: "Media Manager", href: "/media-manager", current: false },
        { name: "Preservatives", href: "/preservatives", current: false },
        { name: "Price Rules", href: "/price-rules", current: false },
        { name: "Production Costs", href: "/production-costs", current: false },
        { name: "Quickbooks", href: "/quickbooks-login", current: false },
        { name: "Supplier items", href: "/supplier-items", current: false },
        { name: "Product Types", href: "/product-types", current: false },
        { name: "Unit of measures", href: "/unit-of-measures", current: false },
        { name: "Users", href: "/users", current: false },
      ],
    },
    {
      name: "QA Setup",
      icon: ChartBarSquareIcon,
      current: false,
      showInMenu: !isCFIA && !sunDistribution && isFeatureFlag("isQa"),
      open: false,
      children: [
        {
          name: "Equipment",
          href: "/process-rnd-equipment",
          current: false,
        },
        { name: "Laboratories", href: "/laboratories", current: false },
        { name: "Process Statuses", href: "/process-statuses", current: false },
        { name: "Visitor Types", href: "/visitor-types", current: false },
      ],
    },
  ];

  routes.forEach((route) => {
    route.open = false;
    if (route.children) {
      route.children.forEach((child) => {
        child.current = false;
        if (child.href === pathname) {
          route.open = true;
          child.current = true;

          title = child.name;
        }
      });
    } else if (route.href === pathname) {
      route.current = true;

      title = route.name;
    }
  });

  var returnArray = {
    routes: routes.filter((route) => route.showInMenu),

    title: title,
  };

  return returnArray;
}
